import angular from 'angular';

angular.module('cloudX').directive('validateWebsite', [
  function() {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        if (!ngModel) return;
        ngModel.$validators.website = function(modelValue) {
          //Allow empty, use the required validator to block empty values
          if (typeof modelValue === 'undefined' || modelValue === null || modelValue.length === 0)
            return true;
          return /^(http\:\/\/|https\:\/\/)?([a-z0-9][a-z0-9\\-]*\.)+[a-z0-9][a-z0-9\\-]*([\/?#].*)?$/i.test(
            modelValue,
          );
        };
        if (bindErrors) {
          bindErrors.addError('website', 9, ['Website']);
          //ngModel.$viewChangeListeners.push(function () {
          //    bindErrors.refreshErrors(ngModel.$error);
          //});
          //scope.$on('$destroy', function () {
          //    bindErrors.refreshErrors();
          //});
        }
      },
    };
  },
]);
